module.exports = __webpack_public_path__ + "img/disc-drive.a5bdd47f.svg";